<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/genres">ジャンル</router-link></li>
                <li class="breadcrumb-item">小説一覧</li>
            </ol>
        </nav>
        <div class="container">
            <legend>
                {{genre.genre_name}}
                <span v-if="genre.is_hondana">展示一覧</span>
                <span v-else>小説一覧</span>
            </legend>
            <div class="text-muted small p-2 my-2" v-if="genre.is_hondana">
                展示棚の作品を削除できます。<br>
                非公開作品が追加されている場合はここから確認することができます。
            </div>
            <div class="text-muted small p-2 my-2" v-else>
                ジャンルの小説を追加します。<br>
                ひとつの小説はひとつのジャンルに登録できます。
                複数のジャンルをまたいで登録することはできません。
            </div>
            <div class="text-right my-2" v-if="!genre.is_hondana">
                <button type="button" class="btn btn-outline-primary" @click="showBooks()">
                    <i class="fas fa-plus"></i>
                    小説追加
                </button>
            </div>
            <div v-if="books.length">
                <div class="card my-2" v-for="b in books" :key="b.id">
                    <div class="card-body">
                        <h5 class="card-title">
                            <span class="handle">{{b.title}}</span>
                            <span class="badge badge-secondary" v-if="!b.is_long">短編</span>
                            <span class="badge badge-danger" v-if="b.is_hidden >= 2">非公開作品</span>
                            <button type="button" class="close" @click="remove(b.id)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </h5>
                        <p class="card-text text-muted">{{$filters.truncate(b.description)}}</p>
                    </div>
                </div>
            </div>
            <div class="nothing" v-else>
                小説がありません。<br>
                小説を追加してください。
            </div>
        </div>
        <books-modal :genre_id="$route.params.genre_id" @saved="load()"></books-modal>
    </div>
</template>

<script>
import booksModal from "./booksModal";
export default {
    components: {
        booksModal
    },
    data() {
        return {
            books: [],
            genre: {},
        }
    },
    methods: {
        load() {
            this.loadBooks();
            this.loadGenre();
        },
        loadGenre() {
            axios.get("/mypage/genre/get", {params: {id: this.$route.params.genre_id}}).then(res => {
                this.genre = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        loadBooks() {
            axios.get("/mypage/genre/books/get", {params: {genre_id: this.$route.params.genre_id}}).then(res => {
                this.books = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        showBooks() {
            $("#genre-books-modal").modal();
        },
        remove(id) {
            Swal.fire({
                title: "小説削除",
                html: `<div class="text-left">
                    指定の小説をジャンルから削除します。<br>
                    小説自体は削除されません。<br>
                    削除しますか？
                    </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    if (this.genre.is_hondana) {
                        axios.post("/mypage/genre/book/remove/hondana", {
                            'id': id,
                            'genre_id': this.genre.id
                        }).then(res => {
                            alert.msg(res.data);
                            this.load();
                        }).catch(err => {
                            alert.err(err.response);
                        });
                    } else {
                        axios.post("/mypage/genre/book/remove", {'id': id}).then(res => {
                            alert.msg(res.data);
                            this.load();
                        }).catch(err => {
                            alert.err(err.response);
                        });
                    }
                }
            });
        }
    },
    mounted() {
        this.load();
    }
}
</script>